




















































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { componentDataType } from "../types";
import GoogleMapsLoader from "google-maps";
import { GMAP_KEY,HOST, API_URL } from "../global";
import { ADD_ANIMATION } from "../store/mutations.names";
import { TimelineMax, Power1, Power2, Power4, Power3 } from "gsap";
import axios from "axios";

const DEFAULT_CONTACT_FORM = {
  full_name: "",
  email: "",
  phone_number: "",
  company: "",
  message: ""
};

@Component({
  name: "ContactPage"
})
export default class ContactPage extends Vue {
  @Prop() public compData!: any | null;
  public HOST: string = HOST;
  @Prop() public last!: boolean;
  @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
  @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
  @Mutation(ADD_ANIMATION) public [ADD_ANIMATION]: any;
  public addedAnimation: boolean = false;

  public contactForm: any = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
  showForm: boolean = false;
  viewMap: boolean = false;
  submitted: boolean = false;
  submitSuccess: boolean = false;

  resetForm() {
    this.contactForm = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
  }

  submitForm() {
    this.$validator.validate().then(valid => {
      if (valid) {
        axios
          .post(`${API_URL}/contact-form/`, this.contactForm)
          .then((resp: any) => {
            this.submitted = true;
            this.submitSuccess = true;
          })
          .catch((err: any) => {
            this.submitted = true;
          });
      }
    });
  }

public showingmap(): void{

let mbdisplay = window.matchMedia("screen and (max-width: 991px)")
if (mbdisplay.matches){ 
 // console.log('mobile');
  this.viewMap = true;
}
else{
   this.viewMap = false;
 // console.log('pc');
}

  }



  contactTransition() {
    var conform = new TimelineMax({});
    conform
    .fromTo(
      "#mySidenav",
      0.4,
      {
        css: {width: "0"},
        opacity: 0.6
        
      },
       {
        css: {width: "calc(100% + 45px)"},
        opacity: 1,
        ease: Power4.easeOut,
      }
    );
  }

  mapTransition() {
    var mapanim = new TimelineMax({});
    mapanim
    .fromTo(
      "#mySidenav2",
      0.4,
      {
        css: {width: "0"},
        opacity: 0.6
        
      },
       {
        css: {width: "calc(100% - 15px)"},
        opacity: 1,
        ease: Power4.easeOut,
      }
    );
  }
  

data() {
   return {
      message: 'View Map'
   }
 }

 changeText() {
   if(this.viewMap){
   
   (this as any).message = "close map";
   }
   else{
   (this as any).message = "View Map";
   }
   
 }

  public contactanim(): void {
    var contanim = new TimelineMax({
      onComplete: () => {
        this.addedAnimation = true;
      } 
    });
    contanim
    .set('.cimg-wrap img', { 
            opacity: 0
          })
      .fromTo(
        ".cimg-wrap img",
        1,
        { 
         
          xPercent: -100,
          opacity: 0
          
          },
        {
          xPercent: 0,
          opacity: 1,
          ease: Power2.easeOut,
          clearProps: "all"
        },"+=0.1")
      .from(".sub-title", 0.8, {
        yPercent: 40,
        opacity: 0,
        ease: Power1.easeOut,
        clearProps: "all"
      })
      .staggerFromTo(
        ".address p",
        .8,
        {
          yPercent: 40,
          opacity: 0,
          ease: Power1.easeOut
        },
        {
          yPercent: 0,
          opacity: 1,
          ease: Power1.easeOut,
          clearProps: "all"
        },
        0.15,
        "-=0.7"
      )
      .staggerFrom(
        ".contact-button",
        0.1,
        {
          autoAlpha: 0,
          opacity: 0,
          ease: Power4.easeIn,
          clearProps: "all"
        },
        0.11,
        "-=1.1"
      )
      .staggerFrom(
        ".btn",
        0.6,
        {
          scale: .95,
          autoAlpha: 0,
          opacity: 0,
          ease: Power2.easeOut,
          clearProps: "all"
        },
        0.01,
        "-=1"
      )
      .staggerFrom(
        "#myButton",
        0.6,
        {
          scale: .95,
          autoAlpha: 0,
          opacity: 0,
          ease: Power2.easeOut,
          clearProps: "all"
        },
        0.01,
        "-=.2"
      );
    if (this.last) {
      this.$emit("loaded");
    }
  }

 public contactGmap(compData = this.compData) {
    if (compData == null || !compData) {
      return null;
    }
    GoogleMapsLoader.KEY = GMAP_KEY;
    GoogleMapsLoader.VERSION = "3.36";

    GoogleMapsLoader.load((google: any) => {
      const latLong = new google.maps.LatLng(
        parseFloat(compData!.latitude),
        parseFloat(compData!.longitude)
      );
      const mapOptions = {
        zoom: 19,
        center: latLong,

        styles: 
        [
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 20
            },
            {
                "color": "#ececec"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#e8e8e3"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#e8e8e3"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#dcdcd2"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#dcdcd2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 21
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#dcdcd2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#303030"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "saturation": "-100"
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.government",
        "elementType": "all",
        "stylers": [
            {
               "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "all",
        "stylers": [
            {
              "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "all",
        "stylers": [
            {
               "visibility": "on"
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "lightness": "-61"
            },
            {
                "gamma": "0.00"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#f7f5f0"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f7f5f0"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f7f5f0"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dce8e5"
            },
            {
                "lightness": 17
            }
        ]
    }
]
      };
      const contmap = new google.maps.Map(
        this.$refs.contgmaps as HTMLElement,
        mapOptions as any
      );
      let iconBase = 'http://rdldev.codesign.com.bd/api/v2/images/ZdQe1oUWj5mmFPkPS-VLETQh7Ro=/119/original/';
      const marker = new google.maps.Marker({
        position: latLong,
        icon: iconBase + 'gmap.png'
      });
      marker.setMap(contmap);
    });
  }

  public mounted() {
   this.showingmap();
    this.$nextTick(() => {
     this.contactGmap();
    });
        
  }
}
